import helpers, { hasBodyClass } from "../../js/helpers.js";
(hasBodyClass("product-template") || hasBodyClass("product-gift-card-template")) && !hasBodyClass("product-suit-kit-template") && import("../../js/prodify.js");

export function start() {}